module.exports = __webpack_public_path__ + "img/headerBanner2.f8060bf3.png";